import React from 'react'

function Code() {
  return (
    <div>
        <p className='header_Problem'>Bibtex</p>
     <div className='code'>
     <div class="citation">Advait Gaur, Aditya Padhy, Aansh chandrakant  Dubey, Aniiket singh , Qazi Talha Ali
    <p class = "title">"Movie Recommendation system"</p>
    <p class = "title">Github ,Streamlit, Movielens ,TMDB API </p>
    <a href="https://prmlmovierecommendationsystem.streamlit.app/" class="title">https://prmlmovierecommendationsystem.streamlit.app/</a>

</div>
     </div>
    </div>
  )
}

export default Code
